module.exports = __webpack_public_path__ + "empty-cell.71ee0051.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/empty-cell.svg
 ** module id = 212
 ** module chunks = 0
 **/